import React, { PropsWithChildren, ReactNode, useRef, useState } from "react"
import { ClickAwayListener, Grid2, Paper, PopperPlacementType } from "@mui/material"

import { PrimitivePopper } from "@/primitives/PrimitivePopper"
import useStyles from "@/components/Sidebar/NavPopper/styles"

type NavPopperProps = PropsWithChildren<{
	panelContent: ReactNode
	placement?: PopperPlacementType
}>

export const NavPopper = ({ children, panelContent, placement }: NavPopperProps) => {
	const classes = useStyles()
	const anchorRef = useRef<HTMLDivElement>(null)
	const [isOpen, setIsOpen] = useState(false)

	const handleOpen = () => setIsOpen(true)
	const handleClose = () => setIsOpen(false)

	return (
		<Grid2 size={12} ref={anchorRef} onMouseEnter={handleOpen} onMouseLeave={handleClose}>
			{children}

			<PrimitivePopper open={isOpen} anchorEl={anchorRef.current} placement={placement ?? "right-start"} sx={classes.popper}>
				<ClickAwayListener onClickAway={handleClose}>
					<Paper elevation={0} sx={classes.panel} onMouseEnter={handleOpen} onMouseLeave={handleClose}>
						{panelContent}
					</Paper>
				</ClickAwayListener>
			</PrimitivePopper>
		</Grid2>
	)
}
